// src/views/scannedData/utils.js
export const formatDate = (ts) =>
  new Date(Number(ts)).toLocaleDateString(undefined, {
    year: "2-digit",
    month: "numeric",
    day: "numeric",
  });

export const formatTime = (ts) =>
  new Date(Number(ts)).toLocaleTimeString([], { hour12: false });

export const truncate = (text, len = 10) =>
  text?.length > len ? `${text.slice(0, len)}.....` : text || "";
